export const EMAIL_SKELETONS = "/api/pa/Reference/MailTemplates"
export const EMAIL_SKELETON = "/api/pa/Reference/MailTemplate/:param"
